import { assertFunction, assertString } from "../helpers/assertFunctions";
import { EventHandlerEmptyException, NamespaceNotValidException } from "../exception/Exception";
function filterKeys(key, namespace, includeNS) {
    if (includeNS === void 0) { includeNS = true; }
    return includeNS ? key : key.replace(new RegExp("^" + namespace + "."), "");
}
var Event = /** @class */ (function () {
    function Event() {
        var _this = this;
        // handler map
        this.handler = {};
        this.getKeysFromNameSpace = function (nss) {
            assertString(nss, "Namespace (dot split)");
            var keys = [];
            nss.split(" ").forEach(function (ns) {
                var allKeys = _this.keys;
                var onceEventKey = Event.ONCE_EVENT_NS + "." + ns;
                for (var i = 0; i < allKeys.length; i++) {
                    var key = allKeys[i];
                    // 全匹配
                    if (ns === key || key === onceEventKey)
                        keys.push(key);
                    if (key.startsWith(ns + ".") || key.startsWith(onceEventKey + ".")) {
                        keys.push(key);
                    }
                }
            });
            return keys;
        };
        this.removeHandler = function (key) {
            _this.handler[key] = [];
        };
    }
    Object.defineProperty(Event.prototype, "keys", {
        get: function () {
            return Object.keys(this.handler) || [];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 在指定的命名空间上添加事件处理器
     * @param ns 事件命名空间
     * @param callback 事件处理器
     */
    Event.prototype.on = function (ns, callback) {
        this.attach(ns, false, callback);
    };
    /**
     * 只会触发一次的事件
     * @param ns 事件命名空间
     * @param callback 事件处理器
     */
    Event.prototype.once = function (ns, callback) {
        this.attach(ns, true, callback);
    };
    /**
     * 添加事件
     * @param ns 事件命名空间
     * @param once 是否触发一次
     * @param callback 事件处理器
     */
    Event.prototype.attach = function (ns, once, callback) {
        assertString(ns, "Namespace (dot split)");
        assertFunction(callback, "Event");
        var namespace = "";
        if (once) {
            namespace = Event.ONCE_EVENT_NS + "." + ns;
        }
        else {
            namespace = ns;
            if (ns.startsWith(Event.ONCE_EVENT_NS)) {
                throw new NamespaceNotValidException(ns);
            }
        }
        if (!this.handler[namespace]) {
            this.handler[namespace] = [];
        }
        this.handler[namespace].push(callback);
    };
    /**
     * 移除（多个事件空格分割）事件命名空间上的所有事件处理器
     * @param nss
     * @param callback 事件处理器
     */
    Event.prototype.off = function (nss, callback) {
        var _this = this;
        var nsKeys = this.getKeysFromNameSpace(nss);
        if (!callback) {
            nsKeys.forEach(this.removeHandler);
        }
        else {
            nsKeys
                .filter(function (key) { return _this.handler[key].includes(callback); })
                .forEach(function (key) {
                // 移除指定处理器
                _this.handler[key] = _this.handler[key].filter(function (h) { return h !== callback; });
            });
        }
    };
    /**
     * 触发（多个事件空格分割）事件命名空间上的所有事件处理器
     * @param nss 事件命名空间
     * @param data 数据
     */
    Event.prototype.emit = function (nss, data) {
        var _this = this;
        this.getKeysFromNameSpace(nss).forEach(function (key) {
            var handlers = _this.handler[key];
            var onceEvent = key.startsWith(Event.ONCE_EVENT_NS);
            if (handlers.length) {
                handlers.forEach(function (cb) {
                    cb(data);
                    if (onceEvent) {
                        _this.off(key);
                    }
                });
            }
            else {
                if (!onceEvent) {
                    throw new EventHandlerEmptyException();
                }
            }
        });
    };
    /**
     * 移除所有事件处理器
     */
    Event.prototype.removeAll = function () {
        this.keys.forEach(this.removeHandler);
    };
    /**
     * 按命名空间获取所有注册事件名
     * @param namespace 命名空间
     * @param includeNS 是否包含命名空间前缀
     */
    Event.prototype.getKeysByNS = function (namespace, includeNS) {
        if (includeNS === void 0) { includeNS = true; }
        assertString(namespace);
        return this.keys
            .filter(function (key) { return key.startsWith(namespace + "."); })
            .map(function (key) { return filterKeys(key, namespace, includeNS); });
    };
    /**
     * 按命名空间获取所有注册事件
     * @param namespace 命名空间
     * @param includeNS 是否包含命名空间前缀
     */
    Event.prototype.getByNS = function (namespace, includeNS) {
        var _this = this;
        if (includeNS === void 0) { includeNS = true; }
        return this.getKeysByNS(namespace).map(function (key) { return ({
            key: filterKeys(key, namespace, includeNS),
            handler: _this.handler[key],
        }); });
    };
    /**
     * 打印调试数据
     */
    Event.prototype.debug = function () {
        var _this = this;
        console.debug("\n=====");
        console.debug("Keys: ", this.keys);
        this.keys.forEach(function (ns) {
            console.debug("evt=" + ns.split(" ") + ", handlers=" + _this.handler[ns]);
        });
        console.debug("=====");
    };
    Event.ONCE_EVENT_NS = "__once__";
    return Event;
}());
export { Event };
